import React from 'react';
import { useStyletron } from 'baseui';

interface CodeSnippetViewerProps {
	code: string;
	language?: string;
	highlightLine?: number;
	filePath?: string;
	lineNumber?: number;
}

const CodeSnippetViewer: React.FC<CodeSnippetViewerProps> = ({ code, filePath, lineNumber }) => {
	const [css] = useStyletron();

	return (
		<div
			className={css({
				borderRadius: '8px',
				overflow: 'hidden',
				border: '1px solid #E2E2E2',
				marginBottom: '8px'
			})}>
			{filePath && (
				<div
					className={css({
						backgroundColor: '#2D2D2D',
						color: '#A0A0A0',
						padding: '6px 12px',
						fontSize: '12px',
						fontFamily: 'monospace'
					})}>
					{filePath}
					{lineNumber ? `:${lineNumber}` : ''}
				</div>
			)}
			<pre
				className={css({
					backgroundColor: '#1E1E1E',
					color: '#D4D4D4',
					padding: '12px 16px',
					margin: '0',
					fontSize: '13px',
					fontFamily: "'Courier New', Courier, monospace",
					lineHeight: '1.5',
					overflowX: 'auto',
					whiteSpace: 'pre-wrap',
					wordBreak: 'break-word'
				})}>
				<code>{code}</code>
			</pre>
		</div>
	);
};

export default CodeSnippetViewer;
